var NAMESPACE = 'td';

var VirtualList = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-virtual-list", style: { height: _vm.containerHeight + 'px' }, on: { "scroll": _vm.handleScroll } }, [_c('div', { staticClass: "td-virtual-list__phantom", style: {
        height: _vm.contentHeight
      } }), _vm._v(" "), _c(_vm.contentTag, { ref: "content", tag: "component", staticClass: "td-virtual-list__wrapper" }, _vm._l(_vm.visibleData, function (item, index) {
      return _c(_vm.itemTag, { key: item.value, tag: "component", staticClass: "td-virtual-list__item", style: {
          height: _vm.itemHeight + 'px'
        } }, [_vm._t("item", null, { "row": item, "index": index + _vm.startIndex })], 2);
    }), 1)], 1);
  }, staticRenderFns: [],
  name: NAMESPACE + '-virtual-list',

  components: {},
  props: {
    data: {
      type: Array,
      required: true
    },

    itemHeight: {
      type: Number,
      default: 30
    },
    containerHeight: {
      type: Number,
      required: true
    },
    contentTag: {
      type: String,
      default: 'div'
    },
    itemTag: {
      type: String,
      default: 'div'
    }
  },

  watch: {
    data: function data() {
      var _this = this;

      this.contentHeight = this.data.length * this.itemHeight + 'px';
      this.$nextTick(function () {
        _this.handleScroll();
      });
    }
  },
  mounted: function mounted() {
    this.updateVisibleData();
    this.contentHeight = this.data.length * this.itemHeight + 'px';
  },
  data: function data() {
    return {
      visibleData: [],
      startIndex: 0,
      contentHeight: 0
    };
  },


  methods: {
    updateVisibleData: function updateVisibleData(scrollTop) {
      var itemHeight = this.itemHeight;
      scrollTop = scrollTop || 0;
      var fixedScrollTop = scrollTop - scrollTop % itemHeight;

      var visibleCount = Math.ceil(this.containerHeight / itemHeight);
      var start = this.startIndex = Math.floor(fixedScrollTop / itemHeight);
      var end = start + visibleCount;
      this.visibleData = this.data.slice(start, end);
      this.$refs.content.style.webkitTransform = 'translate3d(0, ' + fixedScrollTop + 'px, 0)';
    },
    handleScroll: function handleScroll() {
      var _this2 = this;

      var cb = function cb() {
        var scrollTop = _this2.$el.scrollTop;
        _this2.updateVisibleData(scrollTop);
      };
      window.requestAnimationFrame ? window.requestAnimationFrame(cb) : cb();
    }
  }
};

VirtualList.install = function (Vue) {
  Vue.component(VirtualList.name, VirtualList);
};

export default VirtualList;
